import { FaVolleyballBall, FaRunning } from "react-icons/fa";

import { GiTennisCourt, GiShuttlecock } from "react-icons/gi";

// Hero Image
import heroImage from "../assets/services/basketball/hero.webp";
import overview1 from "../assets/services/basketball/overview1.jpg";
import overview2 from "../assets/services/basketball/overview2.jpg";
import overview3 from "../assets/services/basketball/overview3.jpg";
import overview4 from "../assets/services/basketball/overview4.jpg";
/* =====================================================
   HERO STATS
===================================================== */

// Gallery Images
import gallery1 from "../assets/services/basketball/gallery1.jpg";
import gallery2 from "../assets/services/basketball/gallery2.jpg";
import gallery3 from "../assets/services/basketball/gallery3.jpg";
import gallery4 from "../assets/services/basketball/gallery4.jpg";

const basketballData = {
  /* =====================================================
     HERO
  ====================================================== */

  slug: "basketball",

  title: "Basketball Court Construction",

  subtitle: "Professional Acrylic Basketball Courts Built to FIBA Standards",

  heroImage,

  overviewImages: [overview1, overview2, overview3, overview4],

  heroStats: [
    {
      value: "250+",
      label: "Courts Built",
    },

    {
      value: "15+",
      label: "Years Experience",
    },

    {
      value: "FIBA",
      label: "Certified/Standard",
    },

    {
      value: "2 Yr",
      label: "Warranty",
    },
  ],

  breadcrumb: ["Home", "Services", "Basketball Court"],

  /* =====================================================
     OVERVIEW
  ====================================================== */

  overview: {
    title: "Professional Basketball Court Construction",

    description:
      "Quality Sports Surface specializes in designing and constructing international-standard basketball courts for schools, colleges, universities, sports academies, clubs, residential communities, and professional sports facilities. We use premium acrylic sports flooring systems engineered for durability, player safety, weather resistance, and exceptional performance.",
  },

  /* =====================================================
     BENEFITS
  ====================================================== */

  benefits: [
    {
      title: "FIBA Standard Construction",
      description:
        "Designed according to international basketball court specifications.",
    },

    {
      title: "Premium Acrylic Surface",
      description:
        "High-performance acrylic flooring with excellent grip and durability.",
    },

    {
      title: "UV & Weather Resistant",
      description:
        "Built to withstand India's harsh climate and heavy rainfall.",
    },

    {
      title: "Low Maintenance",
      description:
        "Minimal maintenance with long-lasting color and surface quality.",
    },
  ],

  /* =====================================================
     CONSTRUCTION PROCESS
  ====================================================== */

  process: [
    {
      step: "01",
      title: "Site Inspection",
      description:
        "Complete site survey, measurements, and technical planning.",
    },

    {
      step: "02",
      title: "Base Preparation",
      description:
        "Concrete or asphalt base preparation with perfect leveling.",
    },

    {
      step: "03",
      title: "Acrylic Coating",
      description:
        "Multiple acrylic layers applied for strength and cushioning.",
    },

    {
      step: "04",
      title: "Court Marking",
      description: "Accurate FIBA-standard basketball court line marking.",
    },

    {
      step: "05",
      title: "Final Inspection",
      description: "Complete quality inspection before project handover.",
    },
  ],

  /* =====================================================
     TECHNICAL SPECIFICATIONS
  ====================================================== */

  specifications: [
    {
      icon: "🏀",
      feature: "Surface Type",
      value: "Premium Acrylic Sports Flooring",
    },

    {
      icon: "🌦",
      feature: "Weather Resistance",
      value: "Excellent",
    },

    {
      icon: "👟",
      feature: "Slip Resistance",
      value: "High Grip Finish",
    },

    {
      icon: "☀",
      feature: "UV Resistant",
      value: "100% UV Stable",
    },

    {
      icon: "🏆",
      feature: "FIBA Standard",
      value: "International Compliant",
    },

    {
      icon: "⏳",
      feature: "Expected Lifespan",
      value: "8+ Years",
    },

    {
      icon: "🛠",
      feature: "Maintenance",
      value: "Low Maintenance",
    },

    {
      icon: "🌍",
      feature: "Court Type",
      value: "Indoor & Outdoor",
    },
  ],

  /* =====================================================
   GALLERY SECTION
====================================================== */

  gallerySection: {
    tag: "FEATURED PROJECTS",

    title: "Our Recent Basketball Court Projects",

    description:
      "Explore some of the premium Basketball courts successfully completed by Quality Sports Surface across India.",
  },
  /* =====================================================
     GALLERY
  ====================================================== */

  gallery: [
    {
      image: gallery1,
      title: "Meridian School Banjara Hills ",
      location: "Hyderbad",
      surface: "Premium Acrylic Basketball Court",
      year: "2025",
    },

    {
      image: gallery2,
      title: "Delhi Public School",
      location: "Jaipur",
      surface: "Professional Acrylic Court",
      year: "2024",
    },

    {
      image: gallery3,
      title: "Sports Academy",
      location: "Lucknow",
      surface: "Outdoor Basketball Court",
      year: "2024",
    },

    {
      image: gallery4,
      title: "University Campus",
      location: "Chandigarh",
      surface: "FIBA Standard Court",
      year: "2023",
    },
  ],

  /* =====================================================
   WHY CHOOSE US — BASKETBALL
====================================================== */

  whyChoose: {
    tag: "WHY CHOOSE US",

    title: "Why Choose Our Basketball Acrylic Flooring?",

    description:
      "We deliver professional basketball flooring systems designed for superior player safety, consistent ball response and high-performance gameplay. From premium hardwood selection to precision installation, we provide complete basketball court flooring solutions built to perform.",

    features: [
      {
        title: "15+ Years Experience",
        description:
          "Over 15 years of experience delivering professional sports flooring and basketball court solutions for schools, academies, clubs, universities and sports facilities across India.",
      },

      {
        title: "1500+ Sports Projects",
        description:
          "Successfully completed 1500+ sports flooring projects, including basketball courts, multi-purpose indoor arenas, educational institutions and professional training facilities.",
      },

      {
        title: "Premium Basketball Hardwood",
        description:
          "We use high-quality sports-grade hardwood selected for durability, uniformity, shock absorption and reliable performance during intense basketball gameplay.",
      },

      {
        title: "Superior Shock Absorption",
        description:
          "Our basketball flooring systems are designed to help reduce impact on players' knees, ankles and joints while providing comfortable and responsive movement across the court.",
      },

      {
        title: "Excellent Ball Bounce & Grip",
        description:
          "Professionally finished basketball floors provide consistent ball response, controlled traction and reliable grip to support quick movements, jumps, stops and changes of direction.",
      },

      {
        title: "Professional Installation",
        description:
          "Our experienced installation team ensures accurate subfloor preparation, precise hardwood installation, professional sanding, line marking and finishing for a high-quality basketball court.",
      },

      {
        title: "FIBA-Style Court Finishing",
        description:
          "Basketball courts can be finished with professional court markings, surface coatings and colour combinations to create a clean, competition-ready playing environment.",
      },

      {
        title: "Durable & Long-Lasting",
        description:
          "High-performance materials and professional finishing help the flooring withstand frequent training sessions, competitive games and continuous indoor sports activity.",
      },

      {
        title: "Custom Court Solutions",
        description:
          "We provide customized basketball flooring solutions based on court dimensions, facility requirements, usage intensity, budget and performance expectations.",
      },

      {
        title: "On-Time Project Delivery",
        description:
          "Our professional project management process helps ensure efficient execution and completion within committed timelines, minimizing disruption to your sports facility.",
      },

      {
        title: "Complete Project Support",
        description:
          "From initial consultation and site assessment to flooring installation, court marking, maintenance guidance and after-sales support, we provide complete project assistance.",
      },

      {
        title: "Maintenance & After-Sales Support",
        description:
          "We provide practical maintenance guidance and ongoing support to help preserve the appearance, grip, durability and playing performance of your basketball flooring.",
      },
    ],
  },

  /* =====================================================
     FAQ
  ====================================================== */

  faqs: [
    {
      question: "How long does basketball court construction take?",
      answer: "Normally between 45-50 days depending on project size.",
    },

    {
      question: "Can acrylic courts be used outdoors?",
      answer:
        "Yes. Acrylic sports flooring is specially designed for outdoor conditions.",
    },

    {
      question: "How many years does the surface last?",
      answer: "With proper maintenance, the surface typically lasts 2 years.",
    },

    {
      question: "Do you construct FIBA-standard courts?",
      answer:
        "Yes. We build basketball courts according to official FIBA specifications.",
    },
  ],

  /* =====================================================
     RELATED SERVICES
  ====================================================== */

  relatedServices: [
    {
      icon: GiTennisCourt,
      title: "Tennis Court",
      description: "Professional ITF Standard Courts",
      link: "/services/tennis-court",
    },

    {
      icon: GiShuttlecock,
      title: "Badminton Court",
      description: "Professional BWF Standard Courts",
      link: "/services/badminton-court",
    },

    {
      icon: FaRunning,
      title: "Running Track",
      description: "Athletic Running Track Systems",
      link: "/services/running-track",
    },

    {
      icon: FaVolleyballBall,
      title: "Volleyball Court",
      description: "Professional FIVB Standard Courts",
      link: "/services/volleyball-court",
    },
  ],

  /* =====================================================
     CTA
  ====================================================== */

  cta: {
    title: "Ready to Build Your Basketball Court?",

    description:
      "Talk with our experts today and get a free consultation for your next sports infrastructure project.",
  },
};

export default basketballData;
